<template>
  <div
    class="d-post-image"
    :disabled="isDisabled"
  >
    <div v-if="!!imageSrc">
      <div class="grid-flex grid-no-response">
        <div class="grid-item">
          <h4>Post image</h4>
        </div>
        <div class="grid-item-shrink">
          <button
            class="button-grey button-icon button-sm button-close"
            title="Remove image"
            @click="removeImage()"
          />
        </div>
      </div>

      <div class="text-center space-top-1em">
        <img
          :src="imageSrc"
          title="Post image"
        >
      </div>
    </div>

    <div v-else>
      <div class="grid-flex grid-no-response">
        <div class="grid-item">
          <h4>Upload an image</h4>
        </div>
        <div
          v-if="!postInfo.isEditing"
          class="grid-item-shrink"
        >
          <button
            class="button-grey button-icon button-sm button-close"
            title="Cancel"
            @click="clearPostType()"
          />
        </div>
      </div>

      <DuiFileUpload
        :accepted-types="['image/jpeg', 'image/png']"
        upload-button-text="Upload an image"
        class="space-top-1em"
        title="Upload an image"
        @file-updated="updateImage"
      />
    </div>
  </div>
</template>

<script>
import postTypeMixin from '../post-type-mixin';
import { POST_TYPES } from '@d-shared/config';

export default {
  mixins: [
    postTypeMixin,
  ],
  props: {
    isDisabled: {
      type: Boolean,
      default: false,
    },
    postInfo: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    imageFile: null,
    imageSrc: null,
  }),
  beforeDestroy() {
    this.$set(this.postInfo, 'image', null);
  },
  mounted() {
    this.setEditingContent();
  },
  methods: {
    blinkImage() {
      this.$el.classList.remove('blink');
      setTimeout(() => {
        this.$el.classList.add('blink');
      }, 100);
    },

    setEditingContent() {
      if (!this.postInfo.image) {
        return;
      }

      this.$set(this, 'imageSrc', this.postInfo.image.src);
    },

    removeImage() {
      this.$set(this, 'imageFile', null);
      this.$set(this, 'imageSrc', null);
      this.$set(this.postInfo, 'image', null);
    },

    updateImage(imageFile) {
      this.$set(this, 'imageFile', imageFile);
      this.$set(this, 'imageSrc', URL.createObjectURL(imageFile));
      this.$set(this.postInfo, 'image', {
        file: this.imageFile,
        src: this.imageSrc,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@dui-styles/base";

.d-post-image {
  &[disabled] {
    opacity: $disabled-opacity;
    pointer-events: none;
  }

  &.blink,
  &.blink h4 {
    animation-duration: $transition-time-blink;
    animation-fill-mode: forwards;
  }

  &.blink {
    animation-name: blink-border-red;

    h4 {
      animation-name: blink-color-red;
    }
  }

  img {
    border-radius: $border-radius-lg;
  }
}
</style>
